import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs/internal/Observable';
import { AppComponent } from 'src/app/app.component';
import { DEFAULT_LANG, LANGUAGES, LINK_CONTACT_US_DE, LINK_CONTACT_US_EN, LINK_CONTACT_US_ES, LINK_CONTACT_US_FR, LINK_CONTACT_US_IT, LINK_CONTACT_US_NL, LINK_CONTACT_US_PL } from 'src/app/conf/languages';
import { Lang } from 'src/app/model/lang';
import { LanguageDialogComponent } from 'src/app/modules/shared/components/language/language.dialog.component';
import { StandardDesignParameters, StandardFooterLayout, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { AppState } from 'src/app/store/app.reducer';
import { selectCurrentLang } from 'src/app/store/user/user.selector';

@Component({
	selector: 'app-password-update-footer',
	templateUrl: './password-update.footer.component.html',
	providers: [DialogService]
})
export class PasswordUpdateFooterComponent implements OnInit {
	loginForm: FormGroup;
	showPassword = false;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;

	flagImagePath = './assets/images/flags/';
	flagImageFormat = '.svg';

	screenWidth: any;
	FOOTER_EXTENDED_MIN_WIDTH = StandardDesignParameters.FOOTER_EXTENDED_MIN_WIDTH;

	ref: DynamicDialogRef | undefined;

	constructor(
		private store: Store<AppState>,
		public dialogService: DialogService,
		private translate: TranslateService,
		public app: AppComponent,
	) {
		this.loginForm = new FormGroup({
			'username': new FormControl('', Validators.required),
			'password': new FormControl('', Validators.required)
		});
	}

	ngOnInit(): void {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.currentLang$.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.onResize();
	}

	getMenuTheme(): string {
		return this.app.menuTheme;
	}

	getPrivacyButtonStyleClass(): string {
		const stndBtn = "p-button-footer-privacy text-sm";
		if (this.getMenuTheme() === 'dim') {
			return stndBtn
		} else {
			return stndBtn + " text-0"
		}
	}

	changeLanguage() {
		this.ref = this.dialogService.open(LanguageDialogComponent, {
			header: this.translate.instant('SEL_LANGUAGE'),
			contentStyle: { overflow: 'auto' },
		});
	}

	copyrightInfo(): string {
		return StandardFooterLayout.getCopyrightInfo(this.translate);
	}

	getCurrentLanguageName(): string {
		return this.currentLang.name;
	}

	getCurrentLanguageFlag(): string {
		const currentLangFlagFile = this.flagImagePath + this.currentLang.code + this.flagImageFormat;
		return currentLangFlagFile;
	}

	openNewTabContactUs() {
		let url = LINK_CONTACT_US_EN;
		switch (this.currentLang.code) {
			case 'it-IT': {
				url = LINK_CONTACT_US_IT;
				break;
			}
			case 'es-ES': {
				url = LINK_CONTACT_US_ES;
				break;
			}
			case 'de-DE': {
				url = LINK_CONTACT_US_DE;
				break;
			}
			case 'pl-PL': {
				url = LINK_CONTACT_US_PL;
				break;
			}
			case 'nl-NL': {
				url = LINK_CONTACT_US_NL;
				break;
			}
			case 'fr-FR': {
				url = LINK_CONTACT_US_FR;
				break;
			}
			default: {
				url = LINK_CONTACT_US_EN;
				break;
			}
		}
		window.open(url, '_blank');
	}

	openNewTab(url: string) {
		window.open(url, '_blank');
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}
